import {createSelector} from "reselect";
import queryString from 'query-string';
import _ from 'lodash';


const penaltiesUrlSelector = (props: any) => {
    return props.location.search
};

export const penaltiesSortReSelector = createSelector(
    [penaltiesUrlSelector],
    (queryParams) => {
        const getParams = queryString.parse(queryParams);
        const params = _.pick(getParams, ['orderBy']);

        let orderBy = {} as {[key:string]: string};
        if(params.orderBy &&  typeof params.orderBy === "string") {
            const orderByArray = params.orderBy.split('_');
            orderBy[orderByArray[0]] = orderByArray[1] + '_' + orderByArray[2];
        }

        const sort = _.pickBy(orderBy, function(value) {
            return !(value === undefined || value === null || value === '');
        });

        return !_.isEmpty(sort) ? {orderBy:sort} : undefined
    }
);

export const penaltiesFilterReSelector = createSelector(
    [penaltiesUrlSelector],
    (queryParams) => {
        const getParams = queryString.parse(queryParams);
        const params = _.pick(getParams, ['id', 'name', 'description', 'price']);

        const id = params.id ? +params.id : undefined;
        const name = params.name;
        const description = params.description;
        const price = params.price ? +params.price : undefined;

        const filter = _.pickBy({id, name, description, price}, function(value) {
            return !(value === undefined || value === null || value === '');
        });

        return !_.isEmpty(filter) ? filter : undefined
    }
);

